export default "__VITE_ASSET__B2r9cCMp__"